/*
 * Ashe Design – "Your Photoshop plugin key" box.
 *
 * Adds Show/Hide and Copy to the key box on the Remove Background page.
 * The key itself is built in Liquid (templates/page.remove-background.liquid).
 * This file works on its own. It does not depend on bg-removal.js.
 */
(function () {
  'use strict';

  var MESSAGE_MS = 6000;
  var MESSAGES = {
    copied: 'Copied! Now paste it into the plugin in Photoshop.',
    copyBlocked: 'Your browser blocked copying. The key is selected. Press Ctrl+C (Cmd+C on a Mac) to copy it.',
    missing: 'Your key could not be loaded. Please refresh the page.'
  };

  /* ---------- Copy helpers ---------- */

  // Modern way. Needs https, which ashedesign.com has.
  function copyWithClipboardApi(text) {
    if (!navigator.clipboard || !window.isSecureContext) {
      return Promise.reject(new Error('Clipboard API not available'));
    }
    return navigator.clipboard.writeText(text);
  }

  // Older way. Browsers refuse to copy from a password box,
  // so the box is switched to plain text for a moment.
  function copyWithSelection(input) {
    var originalType = input.type;
    var ok = false;
    input.type = 'text';
    input.focus();
    input.select();
    input.setSelectionRange(0, input.value.length);
    try {
      ok = document.execCommand('copy');
    } catch (err) {
      ok = false;
    }
    input.type = originalType;
    return ok;
  }

  /* ---------- View: the only code that touches the page ---------- */

  function createView(box) {
    var input = box.querySelector('[data-bgr-key-input]');
    var toggle = box.querySelector('[data-bgr-key-toggle]');
    var copy = box.querySelector('[data-bgr-key-copy]');
    var message = box.querySelector('[data-bgr-key-message]');
    var timer = null;

    if (!input || !toggle || !copy || !message) {
      return null;
    }

    return {
      input: input,
      toggle: toggle,
      copy: copy,

      getKey: function () {
        return (input.value || '').trim();
      },

      isShown: function () {
        return input.type === 'text';
      },

      setShown: function (shown) {
        input.type = shown ? 'text' : 'password';
        toggle.textContent = shown ? 'Hide' : 'Show';
        toggle.setAttribute('aria-pressed', String(shown));
      },

      // Shows the key and selects it, so the customer can press Ctrl+C.
      selectForManualCopy: function () {
        this.setShown(true);
        input.focus();
        input.select();
      },

      enable: function () {
        toggle.disabled = false;
        copy.disabled = false;
      },

      showMessage: function (text, isError) {
        clearTimeout(timer);
        message.textContent = text;
        message.classList.toggle('bgr-key__message--error', Boolean(isError));
        if (!isError) {
          timer = setTimeout(function () {
            message.textContent = '';
          }, MESSAGE_MS);
        }
      }
    };
  }

  /* ---------- Controller ---------- */

  function init() {
    var box = document.querySelector('[data-bgr-key-box]');
    if (!box) {
      return; // Not logged in, or the box isn't on this page.
    }

    var view = createView(box);
    if (!view) {
      console.error('[bgr-key] Key box is missing one of its parts.');
      return;
    }

    if (!view.getKey()) {
      view.showMessage(MESSAGES.missing, true);
      return; // Buttons stay disabled.
    }

    view.toggle.addEventListener('click', function () {
      view.setShown(!view.isShown());
    });

    view.copy.addEventListener('click', function () {
      var key = view.getKey();
      copyWithClipboardApi(key)
        .then(function () {
          view.showMessage(MESSAGES.copied, false);
        })
        .catch(function () {
          if (copyWithSelection(view.input)) {
            view.showMessage(MESSAGES.copied, false);
          } else {
            view.selectForManualCopy();
            view.showMessage(MESSAGES.copyBlocked, true);
          }
        });
    });

    view.enable();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();